import React, { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { Sparkles } from "lucide-react";

/** Gemini's likely cause and first check for one fault, cached per fault. */
export function AiTriage({ fault }) {
  const [state, setState] = useState({ loading: true, text: null, error: null });

  const load = useCallback(async () => {
    if (!fault?.site_id || !fault?.rule_id) return;
    setState({ loading: true, text: null, error: null });
    try {
      const { data } = await api.post("/ai/faults/triage", {
        site_id: fault.site_id, rule_id: fault.rule_id, rule: fault.rule,
        equip: (fault.equips || [])[0] || fault.equip || null,
        hours: fault.hours ?? null, cost: fault.cost ?? null,
      });
      setState({ loading: false, text: data.text, error: data.error });
    } catch (e) {
      setState({ loading: false, text: null, error: e?.response?.data?.detail || e.message });
    }
  }, [fault]);

  useEffect(() => { load(); }, [load]);

  return (
    <div className="mt-4 rounded-lg bg-[#F3F8F7] border border-[#DCE8E4] p-4" data-testid="ai-triage">
      <div className="flex items-start gap-2.5">
        <Sparkles className="h-4 w-4 text-[#156F5B] mt-0.5 shrink-0" />
        <div className="min-w-0">
          <div className="k-label">Likely cause &amp; first check</div>
          {state.loading ? (
            <p className="mt-1.5 text-sm text-[#9CA3AF]" data-testid="ai-triage-loading">Thinking it through…</p>
          ) : state.text ? (
            <p className="mt-1.5 text-sm text-[#212121] leading-relaxed" data-testid="ai-triage-text">{state.text}</p>
          ) : (
            <p className="mt-1.5 text-sm text-[#9CA3AF]" data-testid="ai-triage-empty">{state.error || "No suggestion available."}</p>
          )}
        </div>
      </div>
    </div>
  );
}
